
import worker from "!!../../../../node_modules/worker-loader/dist/runtime/inline.js";

export default function Worker_fn() {
  return worker("(()=>{\"use strict\";var e,a=self,t=0,r=0;a.addEventListener(\"message\",(function(s){var n=s.data,i=n.key,l=n.value;switch(i){case\"timerSet\":0===t&&(t=l,e=setInterval((function(){r+=t,a.postMessage({key:\"timerInterval\",value:r})}),1e3*t));break;case\"timerClear\":0!==t&&(clearInterval(e),t=0,r=0)}}))})();\n", "Worker", undefined, undefined);
}
